import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // ✅ Only redirect if NOT already on public auth pages
      const publicPaths = ['/login', '/forgot-password', '/reset-password'];
      const currentPath = window.location.pathname;
      
      if (!publicPaths.includes(currentPath)) {
        // User session expired while on protected page - redirect to login
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
      // If already on a public auth page, just let the error propagate naturally
    }
    return Promise.reject(error);
  }
);

export default api;